import request from "superagent";

import { getAuthHeader } from "../../../utils/superagent";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchFacilities(filter, project, options: any = {}) {
  options.limit = options.limit || 100000;
  const res = await request
    .post(`${global.api}/facilityprofile/details`)
    .set(await getAuthHeader())
    .send({ filter, project, options });

  return res.body;
}

export async function fetchFacility(id, projection) {
  const res = await request
    .get(`${global.api}/facilityprofile/${id}`)
    .set(await getAuthHeader())
    .query({ projection });

  return res.body;
}
